import { IOptionItem } from "../typings/common";

const validationRules = {
  defaultRequired: { message: "Data harus diisi", value: true },
  maxLength: (maxLength: number, name: string) => ({
    value: maxLength,
    message: `${name} maksimal ${maxLength} karakter`,
  }),
  optionRequired: (value: IOptionItem) => (!!value.value && !!value.label) || "Data harus diisi",
  phoneNumberMaxLength: 15,
  numericalSpecialChar: (value: string) => /^(?!Backspace|Delete$)[e+-]+$/.test(value),
  phoneFormat: (value: string) => {
    if (value !== "") {
      return (
        /^(^\+62|62|^08)(\d{3,4}-?){2}\d{3,4}$/.test(value)
        || "Format tidak sesuai. Cth: 082211334XXX"
      );
    }
    return true;
  },
  emailFormat: (value: string) => {
    if (value !== "") {
      return /^.*@.*\.co.*$/.test(value) || "Format tidak sesuai.";
    }
    return true;
  },
  additionalInfoMaxLength: 250,
  alphanumericOnly: (value: string) => !value.match(/[^A-Za-z0-9_]/g) || "Hanya menerima huruf dan angka",
  moreThanZero: (value: string, name: string) => value !== "0" || `maaf ${name} harus melebihi 0`,
};

export default validationRules;
